import BaseApiAction from '@Actions/base-api-action';
export default class getTeamConfigs extends BaseApiAction {
  runAction() {
    super.invokeCloudFunction({
      name: 'teams-getTeamConfigs',
      payload: {
        ...(this.addFieldIfExists('account_id', this._payload.account_id)),
        ...(this.addFieldIfExists('user_id', this._payload.user_id)),
        ...(this.addFieldIfExists('user_doc_id', this._payload.user_doc_id)),
        ...(this.addFieldIfExists('resolve_user_account', this._payload.resolve_user_account)),
        ...(this.addFieldIfExists('team_config_ids', this._payload.team_config_ids)),
        ...(this.addFieldIfExists('search_query', this._payload.search_query)),
        ...(this.addFieldIfExists('limit', this._payload.limit)),
        ...(this.addFieldIfExists('offset', this._payload.offset))
      }
    });
  }
}
